import React from "react";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import { SecondaryButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import commonStyles from "../styles/Common.styles";

const TeamImportErrors = ({ errors, onCancel }) => {
	const commonClasses = commonStyles();

	return (
		<Box className={commonClasses.boxContainer}>
			<Grid container className={commonClasses.centerContainer}>
				<Grid item md={12}>
					<ul>
						{errors.map((error) => (
							<li>{error}</li>
						))}
					</ul>
				</Grid>
			</Grid>
			<Toolbar className={commonClasses.actionToolbar}>
				<Grid container direction="row" justifyContent="flex-end" spacing={2}>
					<Grid item>
						<SecondaryButton color="secondary" label="Cancel" onClick={onCancel} />
					</Grid>
				</Grid>
			</Toolbar>
		</Box>
	);
};

export default TeamImportErrors;
